import React, { useEffect, useState } from "react";
import {
  ASSEMENT_IMG,
  CUSTOMER_IMG,
  PROJECT_IMG,
} from "../../../utills/image-constant";
import { useSelector } from "react-redux";
import AccessPermissionpage from "./AccessPermissionpage";
import { getAllDashboardDetails } from "../../../services/api-services";
import DashboardChart from "../../components/Charts/DashboardChart";
const Dashboard = () => {
  const { value } = useSelector((state) => state?.adminRole);
  const [permissionAccess, setPermissionAccess] = useState(false);
  const [rowData, setRowData] = useState({});
  const [pending, setPending] = useState()

  useEffect(() => {
    const RoleAccessFilterData =
      value && value?.filter((v) => v.moduleName === "Dashboard");
    setPermissionAccess(RoleAccessFilterData?.[0]);
  }, [value]);

  const getAllDashboardDetailsList = async () => {
    try {
      setPending(true);
      const response = await getAllDashboardDetails();
      if (response?.data?.responseCode === 200) {
        setRowData(response?.data)
        setPending(false);
      }
      else {
        setRowData({});
        setPending(false);

      }
    }
    catch (error) {
      setPending(false)
    }
  }
  useEffect(() => {
    getAllDashboardDetailsList();
  }, [])

  return (
    <>
      {permissionAccess && permissionAccess?.viewAction == 0 ? (
        <AccessPermissionpage />
      ) : (
        <>
          <div className="caspera_dashboard_content">
            <div className="container-fluid px-3">
              <h5 className="mycard mb-3">My Cards</h5>
              <div className="row">
                <div className="col-lg-4 col-md-12 mb-3">
                  <div className="dashboard_left_sec">

                    <div className="first_card d-flex mb-3">
                      <div>
                        <img src={CUSTOMER_IMG} alt="" />
                      </div>
                      <div className="mt-2 ms-3 text-white">
                        <h3 className="mb-1">{rowData.totalCustomers || 0}</h3>
                        <p className="mb-0 text-nowrap">Total Customers</p>
                      </div>
                    </div>
                    <div className="second_card d-flex mb-3">
                      <div>
                        <img src={PROJECT_IMG} alt="" />
                      </div>
                      <div className="mt-2 ms-3 text-white">
                        <h3 className="mb-1">{rowData.totalProjects || 0}</h3>
                        <p className="mb-0 text-nowrap">Total Campaign</p>
                      </div>
                    </div>
                    <div className="third_card d-flex mb-3">
                      <div>
                        <img src={ASSEMENT_IMG} alt="" />
                      </div>
                      <div className="mt-2 ms-3 text-white">
                        <h3 className="mb-1">{rowData.totalAssessment || 0}</h3>
                        <p className="mb-0 text-nowrap">Total Models</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-12  col-lg-8 mb-3">
                  <div className="dashboard_right_sec">
                    <DashboardChart />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Dashboard;
